import * as actionsTypes from "./actionTypes";

export const getSearchdata = ()=>({
    type:actionsTypes.GET_SEARCH_DATA_REQUEST
})
export const resetBillingPageForm = () => ({
    type: actionsTypes.RESET_BILLINGPAGE_FORM
});

export const getBillingData = ()=>({
    type: actionsTypes.GET_BILLING_REPORT_COUNT
})
